
import React from 'react';
import { Zap } from 'lucide-react';

const ExemplesSection = () => {
  const exemples = [
    {
      titre: "Lancement Produit Tech",
      description: "Campagne 360° pour une startup innovante",
      canaux: ["Relations presse", "Réseaux sociaux", "Événement de lancement", "Partenariats influenceurs"],
      resultat: "+400% de notoriété en 3 mois"
    },
    {
      titre: "Repositionnement B2B",
      description: "Transformation de l'image d'une entreprise établie",
      canaux: ["Refonte digitale", "Thought leadership", "Événements sectoriels", "Communication interne"],
      resultat: "+180% d'attractivité candidats"
    },
    {
      titre: "Campagne de Sensibilisation",
      description: "Sensibilisation à une cause sociale",
      canaux: ["Médias traditionnels", "Campagne digitale", "Partenariats associatifs", "Événements communautaires"],
      resultat: "2M+ de personnes touchées"
    }
  ];

  return (
    <section className="py-20 bg-navy-50/30">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-light text-navy-900 mb-6">
              Exemples <span className="font-semibold text-blue-600">concrets</span>
            </h2>
            <p className="text-lg text-navy-600 font-light max-w-2xl mx-auto">
              Des campagnes 360° qui ont marqué les esprits
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            {exemples.map((exemple, index) => (
              <div key={index} className="bg-white p-6 shadow-lg hover:shadow-xl transition-all duration-300">
                <h3 className="text-xl font-semibold text-navy-900 mb-3">{exemple.titre}</h3>
                <p className="text-navy-600 font-light mb-6 text-sm">{exemple.description}</p>
                
                <div className="mb-6">
                  <h4 className="font-medium text-navy-700 mb-3 text-sm">Canaux utilisés :</h4>
                  <div className="flex flex-wrap gap-2">
                    {exemple.canaux.map((canal, canalIndex) => (
                      <span key={canalIndex} className="bg-blue-100 text-blue-700 px-3 py-1 text-xs font-medium">
                        {canal}
                      </span>
                    ))}
                  </div>
                </div>
                
                <div className="border-t pt-4">
                  <div className="flex items-center gap-2">
                    <Zap className="text-pink-500" size={16} />
                    <span className="font-semibold text-pink-500 text-sm">{exemple.resultat}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExemplesSection;
